import React, { ReactNode, useState } from 'react';
import axios from 'axios';
import '../Pincodefinder/Style.css';
import '../Pincodefinder/Track.css';
import Tab from 'react-bootstrap/Tab';
import '../Pincodefinder/Style.css';
import '../Steelcity/css/style.css';
import '../Steelcity/css/bootstrap.min.css';
import '../Steelcity/css/responsive.css';
import Tabs from 'react-bootstrap/Tabs';
import Logo from '../Logo/logo.png';

interface TempodEntry {
  EntryDate: string;
  EntryTime: string;
  Details: string;
  Remark: string;
}

interface TrackingRecord {
  CNoteNo: string;
  InvoiceNo: string;
  ExptDateDelivery: string;
  VendorAwbNo: string;
  bookdate: string;
  ConsigneeName: string;
  Status: string;
  qty: string;
  Destination_Name: string;
  Origin_Name: string;
  Mode: string;
  recvName: string;
  statusDt: string;
  delvTime: string;
  remark: ReactNode;
  tempodData: TempodEntry[];
  ImageLink: string;
}

const JaimarutiTraking: React.FC = () => {
  const [searchValue, setSearchValue] = useState('');
  const [trackingData, setTrackingData] = useState<TrackingRecord[]>([]);
  const [showImage, setShowImage] = useState(false);
  const [error, setError] = useState('');
  const [currentStep, setCurrentStep] = useState(1);



  const statusToStep: { [key: string]: number } = {
    'Shipped': 1,
    'In Transit': 2,
    'Delivered': 3,
  };

  const handleButtonClick = () => {
    setShowImage(!showImage); // Toggle the image visibility
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value.slice(0, 200);
    setSearchValue(inputValue);
    setError('');
    setTrackingData([]);
  };


  const fetchData = async () => {
    try {
      if (searchValue.trim() === '') {
        setError('Please enter one or more tracking numbers separated by commas.');
        return;
      }

      // const CNoteNo = searchValue.split(',').map(awb => awb.trim());
      // const res = await axios.post('https://rajairexpress.com/RajAirTrackingApi/getTrackingData', { CNoteNo });
      // const data = res.data;

      // console.log(data, "Response from API");

      const CNoteNo = searchValue.split(',').map(awb => awb.trim()).join(',');
      const url = `https://jaimarutilogistics.com/JaiAirTrackingApi/getTrackingData?CNoteNo=${CNoteNo}`;

      const res = await axios.get(url);
      const data = res.data;

      console.log(data, "Response from API");


      if (data.status === 1 && data.Data) {
        const updatedData = data.Data.map((item: TrackingRecord) => {
          const imageId = item.CNoteNo; // Assuming CNoteNo is used for image URL
          item.ImageLink = `https://jaimarutilogistics.com/portalapi/PODIMAGE/${imageId}.jpg`; // Create the image URL
          return item; // Return the updated item
        });

        setTrackingData(updatedData); // Update state with the modified data including ImageLink
        setError('');

        // Update the currentStep based on the status of the first record
        if (updatedData.length > 0) {
          const status = updatedData[0].Status; // Assuming status is relevant for the first record
          setCurrentStep(statusToStep[status] || 1); // Default to step 1 if status is unknown
        }
      } else {
        setError('Docket Not Found');
      }
    } catch (error) {
      console.error('Error:', error);
      setError('Failed to fetch data. Please check your internet connection.');
    }
  };



  return (
    <>



      <header className="navbarheader-fluid">
        {/* Top Marquee */}
        <div style={{ backgroundColor: '#08386bff', color: 'white', padding: '10px', textAlign: 'center', fontWeight: 'bold' }}>
          Welcome to Jai Maruti Logistics.com | +91 8424038717 - jaimaruti2004@gmail.com
        </div>


        {/* Desktop Navbar */}
        <div className="navbar-container d-none d-lg-flex">
          <div className="navbar-logo">
            <img
              src={Logo}
              alt="Company Logo"
              className="img-fluid"
              style={{ height: "100px", width: "auto", marginTop: "-20px" }}
            />
          </div>

          <nav className="navbar-links">
            <a href="https://jaimarutilogistics.com/">Home</a>
            <a href="https://jaimarutilogistics.com/about-us.php">About Us</a>
            <a href="https://jaimarutilogistics.com/portal/#/login">Branch_Login</a>
            <a href="https://jaimarutilogistics.com/downloads.php">Document</a>
            <a href="https://jaimarutilogistics.com/contact-us.php">Contact</a>
          </nav>
        </div>

        {/* Mobile Navbar (Offcanvas) */}
        <nav className="navbar bg-light fixed-top d-lg-none">
          <div className="container-fluid">
            {/* Left-side hamburger button */}
            <button
              className="navbar-toggler me-2"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasNavbar"
              aria-controls="offcanvasNavbar"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            {/* Brand Logo (on the right) */}
            <a className="navbar-brand ms-auto" href="#">
              <img
                src={Logo}
                alt="Company Logo"
                style={{ height: "50px", width: "auto" }}
              />
            </a>

            {/* Offcanvas Menu (opens from left) */}
            <div
              className="offcanvas offcanvas-start"
              tabIndex={-1}
              id="offcanvasNavbar"
              aria-labelledby="offcanvasNavbarLabel"
            >
              <div className="offcanvas-header">
                <h5 className="offcanvas-title" id="offcanvasNavbarLabel">
                  Menu
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                ></button>
              </div>

              <div className="offcanvas-body">
                <ul className="navbar-nav justify-content-end flex-grow-1 pe-3">
                  <li className="nav-item">
                    <a href="https://jaimarutilogistics.com/">Home</a>
                  </li>
                  <li className="nav-item">
                    <a href="https://jaimarutilogistics.com/about-us.php">About Us</a>
                  </li>
                  <li className="nav-item">
                    <a href="https://jaimarutilogistics.com/portal/#/login">Branch_Login</a>
                  </li>
                  <li className="nav-item">
                    <a href="https://jaimarutilogistics.com/downloads.php">Document</a>
                  </li>
                  <li className="nav-item">
                    <a href="https://jaimarutilogistics.com/contact-us.php">Contact</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </header>






      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <h5 className='BLuedarttracking'><b> Jai Maruti Tracking Details</b></h5>

            {trackingData.length > 0 ? (
              trackingData.map((record, index) => (
                <div key={index} className="shadow p-4 mb-4">
                  <table className="table table-bordered table-sm mb-4">
                    <thead>
                      <tr>
                        <th>Waybill No</th>
                        <th>Invoice No</th>
                        <th>Expt Date of Delivery</th>
                        <th>Status</th>
                        <th>Date of Delivery</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{record.CNoteNo}</td>
                        <td>{record.InvoiceNo}</td>
                        <td>{record.ExptDateDelivery}</td>
                        <td>{record.Status}</td>
                        <td>{record.statusDt}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ))
            ) : (
              <div>No tracking data available.</div>
            )}

            <div className="steps-container">
              {[1, 2, 3].map(number => (
                <span key={number} className="step-container">
                  {number > 1 && <div className="line"></div>}
                  <span className={`step-circle ${number <= currentStep ? 'active' : ''}`}>
                    {number}
                  </span>
                  <span className="step-label">{number === 1 ? 'Shipped' : number === 2 ? 'In Transit' : 'Delivered'}</span>
                </span>
              ))}
              <div className="progress-bar-container">
                <span
                  className="progress-indicator"
                  style={{ width: `${((currentStep - 1) / 2) * 100}%` }} // Adjusted to 2 for 3 steps
                ></span>
              </div>
            </div>



          </div>

          <div className="col-lg-4">
            <div className="shadow p-4">
              <h1><b className='Track'>TRACK</b></h1>
              <div className="centered-input-container">
                <input
                  type="text"
                  className="form-control mb-3 centered-input"
                  placeholder="Tracking Number(s)"
                  value={searchValue}
                  onChange={handleInputChange}
                />
              </div>
              <button onClick={fetchData} className="Tracking">TRACK</button>
              {error && <div className="text-danger mt-2">{error}</div>}
              <p className="mt-2">To track multiple waybills, enter tracking numbers separated by commas.</p>
            </div>
          </div>
        </div>
      </div >

       <div className="container">
                <div className="row justify-content-start">  {/* ✅ ensures no center alignment */}
                    <div className="col-lg-8 col-md-10 col-sm-12">
                        <Tabs
                            defaultActiveKey="details"
                            id="uncontrolled-tab-example"
                            className="custom-tabs"
                        >
                            <Tab eventKey="details" title="Shipment Details">
                                {trackingData.length > 0 ? (
                                    trackingData.map((record, index) => (
                                        <div key={index} className="shadow p-4 mb-3">
                                            <div className="shipment-details">
                                                <div className="detail-row">
                                                    <span className="detail-label">Waybill No:</span>
                                                    <span className="detail-value">{record.CNoteNo}</span>
                                                </div>
                                                <div className="detail-row">
                                                    <span className="detail-label">Forwarding No:</span>
                                                    <span className="detail-value">{record.VendorAwbNo}</span>
                                                </div>
                                                <div className="detail-row">
                                                    <span className="detail-label">Pickup Date:</span>
                                                    <span className="detail-value">{record.bookdate}</span>
                                                </div>
                                                {/* <div className="detail-row">
                          <span className="detail-label">Mode:</span>
                          <span className="detail-value">{record.Mode}</span>
                        </div> */}
                                                <div className="detail-row">
                                                    <span className="detail-label">From:</span>
                                                    <span className="detail-value">{record.Origin_Name}</span>
                                                </div>
                                                <div className="detail-row">
                                                    <span className="detail-label">To:</span>
                                                    <span className="detail-value">{record.Destination_Name}</span>
                                                </div>
                                                <div className="detail-row">
                                                    <span className="detail-label">Status:</span>
                                                    <span className="detail-value">{record.Status}</span>
                                                </div>
                                                <div className="detail-row">
                                                    <span className="detail-label">Date of Delivery:</span>
                                                    <span className="detail-value">{record.statusDt}</span>
                                                </div>
                                                <div>

                                                    <button className="btn btn-success" onClick={handleButtonClick}>
                                                        {showImage ? 'Hide Image' : 'Pod Image'}
                                                    </button>
                                                    {showImage && (
                                                        <div className="image-container mt-2">

                                                            {trackingData.length > 0 && (
                                                                <img src={trackingData[0].ImageLink} alt="Tracking" className="img-fluid" />
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div>No shipment details available.</div>
                                )}
                            </Tab>

                             <Tab eventKey="status" title="Status and Scans" className="tab-center">
                                {trackingData.length > 0 ? (
                                    trackingData.map((record, index) => (
                                        <div key={index}>
                                            <p><b className='BLuedarttracking'>Status and Scans</b></p>
                                            <div className="scrollable-table">
                                                <table className="table table-bordered table-sm">
                                                    <thead className='background'>
                                                        <tr>
                                                            <th>Location</th>
                                                            <th>Status</th>
                                                            <th>Date</th>
                                                            <th>Time</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {record.tempodData && record.tempodData.length > 0 ? (
                                                            record.tempodData.map((entry, idx) => (
                                                                <tr key={idx}>
                                                                    <td>{entry.Details}</td>
                                                                    <td>{entry.Remark}</td>
                                                                    <td>{entry.EntryDate}</td>
                                                                    <td>{entry.EntryTime}</td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan={4}>No scans available.</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div>No status and scans available.</div>
                                )}
                            </Tab>
                        </Tabs>
                    </div>
                </div>
            </div>


            
     <footer className="Rajair">
  <div className="container">
    <div className="row">
      {/* Column 1 */}
      <div className="col-lg-3 col-md-6 col-sm-12">
        <div className="footer-col">
          <div>
            <img
              src={Logo}
              alt="Company Logo"
              className="img-fluid"
              style={{ height: '100px', width: 'auto', marginTop: '-40px' }}
            />
          </div>
          <p>
            As a privately owned company, we are a highly focused and capable logistics specialist with a strong global presence and extensive agency representation across most countries.
            At <strong>Jai Maruti Logistics.</strong>, client satisfaction is our top priority.
            We are committed to delivering reliable, efficient, and tailored solutions every time.
          </p>
          <div className="social-icons">
            <a href="#"><i className="fab fa-instagram"></i></a>
            <a href="#"><i className="fab fa-facebook"></i></a>
          </div>
        </div>
      </div>

      {/* Column 2 */}
      <div className="col-lg-3 col-md-6 col-sm-12">
        <div className="footer-col">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="https://jaimarutilogistics.com/">Home</a></li>
            <li><a href="https://jaimarutilogistics.com/about-us.php">About Us</a></li>
            <li><a href="https://jaimarutilogistics.com/RajAirTracking/">Track Shipment</a></li>
            <li><a href="https://jaimarutilogistics.com/standard-conditions.php">Standard Conditions of Carriage</a></li>
            <li><a href="https://jaimarutilogistics.com/downloads.php">Downloads</a></li>
            <li><a href="https://jaimarutilogistics.com/blog.php">Blog</a></li>
            <li><a href="https://jaimarutilogistics.com/faq.php">FAQ's</a></li>
            <li><a href="https://jaimarutilogistics.com/contact-us.php">Contact Us</a></li>
            <li><a href="https://jaimarutilogistics.com/privacy-policy.php">Privacy Policy</a></li>
            <li><a href="https://jaimarutilogistics.com/payment-terms.php">Payment Terms and Conditions</a></li>
          </ul>
        </div>
      </div>

      {/* Column 3 */}
      <div className="col-lg-3 col-md-6 col-sm-12">
        <div className="footer-col">
          <h4>Our Services</h4>
          <ul>
            <li>International Document</li>
            <li>International Non-Document</li>
            <li>Food Items</li>
            <li>Medicines</li>
            <li>Ecommerce Logistics</li>
            <li>CSB 5</li>
            <li>B2B</li>
            <li>B2C</li>
            <li>
              <a href="https://jaimarutilogistics.com/services.php">View More</a>
            </li>
          </ul>
        </div>
      </div>

      {/* Column 4 */}
      <div className="col-lg-3 col-md-6 col-sm-12">
        <div className="footer-col">
          <h4>Get in Touch</h4>
          <p>
            Shop No 2,3 Kunji Raman Chawl Parsiwada Opp. Airport Authority Of India Sahar Road,<br />
            Andheri E, Mumbai - 400099
          </p>
          <p>
            <strong>Phone:</strong> +91 8424038717 / +91 8424038718 / +91 8347321111<br />
            <strong>Email:</strong>{' '}
            <a href="mailto:jaimaruti2004@gmail.com">jaimaruti2004@gmail.com</a>
          </p>
        </div>
      </div>
    </div>
  </div>

  {/* Footer Bottom */}
  <div className="footer-bottom text-center py-3 mt-4">
    <p>© 2025 Jai Maruti Logistics. All Rights Reserved.</p>
    <div className="footer-links">
      <a href="https://jaimarutilogistics.com/privacy-policy.php">Privacy & Policy</a>
      <span className="mx-2">|</span>
      <a href="https://jaimarutilogistics.com/payment-terms.php">Terms and Conditions</a>
    </div>
  </div>
</footer>





    </>
  );
};

export default JaimarutiTraking
